import { FunctionComponent } from "react";
import "@rmwc/circular-progress/styles";
import { CircularProgress } from "@rmwc/circular-progress";
import style from "./Spinner.module.scss";

const Spinner: FunctionComponent = () => {
  return (
    <div className={style.Spinner}>
      <CircularProgress size="large" />
    </div>
  );
};

export { Spinner, Spinner as default };
